import percentRound from 'percent-round';
import tableRows from 'constants/tableRows';
import { getDashboardData } from 'modules/society/actions/dashBoardActions';

const getPercents = (capitalData) => {
  const {
    societyActualShares,
    convertibleNotesShares,
    convertibleNotesSharesDraft,
    totalShares,
    totalSharesDrafts,

    stockOptionsTotalShares,
    stockOptionsWithDraftsTotalShares,
    phantomTotalShares,
    phantomWithDraftsTotalShares,
  } = capitalData;

  const percents = totalShares
    ? [
        (societyActualShares * 100) / totalShares,
        (convertibleNotesShares * 100) / totalShares,
        (stockOptionsTotalShares * 100) / totalShares,
        (phantomTotalShares * 100) / totalShares,
      ]
    : [0, 0, 0, 0];

  const percentsWithDrafts = totalSharesDrafts
    ? [
        (societyActualShares * 100) / totalSharesDrafts,
        (convertibleNotesSharesDraft * 100) / totalSharesDrafts,
        (stockOptionsWithDraftsTotalShares * 100) / totalSharesDrafts,
        (phantomWithDraftsTotalShares * 100) / totalSharesDrafts,
      ]
    : [0, 0, 0, 0];

  const roundPercents = percentRound(percents, 2);
  const roundPercentsWithDrafts = percentRound(percentsWithDrafts, 2);

  return { roundPercents, roundPercentsWithDrafts };
};
const getResultData = (capitalData) => {
  const {
    societyActualShares,
    convertibleNotesShares,
    stockOptionsTotalShares,
    phantomTotalShares,
    totalShares,
  } = capitalData;

  const { roundPercents } = getPercents(capitalData);

  return [
    // NO DRAFTS
    {
      type: tableRows.TEXT,
      name: 'Shares',
      value1: societyActualShares,
      value2: roundPercents[0],
    },
    {
      type: tableRows.TEXT,
      name: 'ConvertibleLoans',
      value1: convertibleNotesShares,
      value2: roundPercents[1],
    },
    {
      type: tableRows.TEXT,
      name: 'Stockoptions/Warrants',
      value1: stockOptionsTotalShares,
      value2: roundPercents[2],
    },
    {
      type: tableRows.TEXT,
      name: 'PhantomsharesFD',
      value1: phantomTotalShares,
      value2: roundPercents[3],
    },
    { type: tableRows.TOTAL, name: 'TOTAL', value1: totalShares, value2: 100 },
  ];
};

export const getCapitalViewData = async (societyId, dispatch) => {
  const capitalData = await dispatch(getDashboardData(societyId, 'capital'));

  const resultData = getResultData(capitalData);
  return resultData;
};
